import { axios } from "../../helper/axios";
import { ConnectorsTableconstant } from "./ConnectorsTableConstant";

const ConnectorsTableApi = {};

ConnectorsTableApi.getConnectorsTable = () => {
  return axios.get(ConnectorsTableconstant.CONNECTORS_TABLE_API);
};

ConnectorsTableApi.postPowerMapApi = (payload) => {

  return axios.post(ConnectorsTableconstant.POST_POWER_MAP_API, {
    max_khw: payload.powername,
    time: payload.timename,
    manufacturer_id: payload.manufacturer_id,
    model_id: payload.model_id,
    charger_type_id: payload.charger_type_id,
  });
};

export { ConnectorsTableApi };
